(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidPhysician', CovidPhysician);

    CovidPhysician.$inject = ['$resource'];

    function CovidPhysician ($resource) {
        var resourceUrl =  'api/covid-physicians/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-physicians/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
